<template>
  <BaseModal id="bulk-category-selector" :value="true" @input="$emit('closed')">
    <BaseProductModal
      v-model="showProductModal"
      @closeProduct="openedProduct = ''"
      :code="openedProduct"
    />
    <div class="flex flex-col">
      <div
        class="filters-box flex flex-row top-0 mb-2 w-full bg-white grid grid-cols-2 gap-2"
      >
        <div class="flex flex-col p-2">
          <h2>Parts filters</h2>
          <div class="grid grid-cols-2 gap-2">
            <div class="rounded-md flex flex-col justify-center">
              <label for="search">Search</label>
              <input
                type="text"
                id="search"
                class="bordered regular full"
                placeholder="code or description"
                v-model="filters.search"
                @input="searchFromFirstPage"
              />
            </div>
            <div class="flex flex-col justify-center">
              <label for="with-category">Products with category</label>
              <select
                name="with-category"
                id="with-category"
                class="default-select bordered dull"
                v-model="filters.categoryOnly"
                @change="searchFromFirstPage()"
              >
                <option value="no-category-only">No category only</option>
                <option value="">Any</option>
              </select>
            </div>
          </div>
        </div>
        <div
          class="flex-grow flex justify-start flex-col bg-gray-200 rounded-md overflow-hidden p-2"
        >
          <h2>New category</h2>
          <div class="grid grid-cols-3 gap-2 items-center">
            <div class="flex flex-col">
              <label for="categories">Category</label>
              <select
                name="categories"
                id="categories"
                class="default-select bordered full"
                @change="loadSubcategories()"
                v-model="selectedCategory"
              >
                <option
                  v-for="category in categories"
                  :value="category.id"
                  :key="category.id"
                  @change="loadSubcategories()"
                >
                  {{ category.categoryName }}
                </option>
              </select>
            </div>
            <div class="flex flex-col">
              <label for="categories">Subcategory</label>
              <select
                name="categories"
                id="categories"
                class="default-select bordered full"
                v-model="selectedSubcategory"
              >
                <option
                  v-for="subcategory in subCategoriesOptions"
                  :value="subcategory.id"
                  :key="subcategory.id"
                >
                  {{ subcategory.subCategoryName }}
                </option>
              </select>
            </div>
            <div class="flex justify-center mt-auto">
              <button class="btn-success-button" @click="addCategories()">
                Add ({{ selectedItem.length }} items)
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        id="ai-categorizer"
        class="w-full bg-blue-50 border border-blue-200 rounded-md p-2 mb-2 flex flex-row items-center gap-3 flex-wrap"
      >
        <h2 class="m-0">Auto-categorize with Claude</h2>
        <button
          class="btn-dark-button"
          :disabled="aiRunning || uncategorizedProducts.length === 0"
          @click="runAiCategorization()"
        >
          Categorize {{ uncategorizedProducts.length }} products without
          category
        </button>
        <button
          v-if="aiRunning"
          class="btn-error-button"
          @click="aiCancelled = true"
        >
          Stop
        </button>
        <span v-if="aiRunning" class="text-sm">
          Batch {{ aiProgress.batch }}/{{ aiProgress.totalBatches }} —
          {{ aiProgress.done }}/{{ aiProgress.total }} products analyzed
        </span>
        <span v-if="aiError" class="text-sm text-red-600">{{ aiError }}</span>
        <template v-if="!aiRunning && suggestionsCount > 0">
          <span class="text-sm">
            {{ suggestionsCount }} suggestions ({{
              selectedWithSuggestion.length
            }}
            selected)
            <template v-if="aiUnmatched.length">
              · {{ aiUnmatched.length }} without a confident match
            </template>
          </span>
          <button
            class="btn-success-button"
            :disabled="selectedWithSuggestion.length === 0 || aiApplying"
            @click="applyAiSuggestions()"
          >
            Apply {{ selectedWithSuggestion.length }} suggestions
          </button>
          <button class="btn-info-button" @click="clearAiSuggestions()">
            Discard suggestions
          </button>
        </template>
      </div>
      <BaseMiniSpinner v-if="loading || aiApplying"></BaseMiniSpinner>
      <div v-if="items.products" class="flex flex-row items-center gap-3">
        <span>
          Showing {{ items.products.length }} of {{ items.totalItems }} products
          <template v-if="filters.categoryOnly === 'no-category-only'">
            without category
          </template>
          <template v-if="items.totalPages > 1">
            (page {{ filters.page }} of {{ items.totalPages }})
          </template>
        </span>
        <template v-if="items.totalPages > 1">
          <button
            class="btn-dark-button"
            :disabled="filters.page <= 1 || loading"
            @click="goToPage(filters.page - 1)"
          >
            Prev
          </button>
          <button
            class="btn-dark-button"
            :disabled="filters.page >= items.totalPages || loading"
            @click="goToPage(filters.page + 1)"
          >
            Next
          </button>
        </template>
      </div>
      <div id="filters" class="w-full bg-gray-200 border rounded-md p-4 mt-0">
        <div>
          <input
            id="select-all-cb"
            class="my-5"
            @click.stop
            type="checkbox"
            :value="allSelected"
            @input="selectAll"
          />
        </div>
        <div></div>
        <div>NKR</div>
        <div>Unificado</div>
        <div>Description</div>
        <div>Infoauto description</div>
        <div>
          <span>
            Category
          </span>
          <input
            class="regular bordered center-text clear"
            type="text"
            v-model="tableFilters.category"
          />
        </div>
        <div>Claude suggestion</div>
      </div>
      <div id="filters">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div id="items">
        <div
          class="item-line border border-gray-200"
          v-for="item in filteredProducts"
          :key="item.nkrCode"
          :style="{
            backgroundColor: selectedItem.find(
              selected => selected == item.unificado
            )
              ? '#079d0773'
              : ''
          }"
        >
          <div
            class="flex justify-center"
            @click="selectCheckbox(item.unificado)"
          >
            <input
              class="my-5"
              @click.stop
              type="checkbox"
              :id="item.unificado"
              :name="item.unificado"
              :value="item.unificado"
              v-model="selectedItem"
            />
          </div>
          <div class="flex justify-center" v-if="item.image">
            <img :src="item.image" class="w-16 h-16 p-3" />
          </div>
          <div class="flex justify-center" v-else>
            <img src="@/assets/img/no-image-found.png" class="w-16 h-16 p-3" />
          </div>
          <div
            class="text-blue"
            @click="
              () => {
                showProductModal = true;
                openedProduct = item.nkrCode;
              }
            "
          >
            {{ item.nkrCode }}
          </div>
          <div>{{ item.unificado }}</div>
          <div>{{ item.customTitle }}</div>
          <div>{{ item.originalTitle }}</div>
          <div :title="item.category" class="category-field">
            {{ item.category }}
          </div>
          <div class="suggestion-field">
            <template v-if="aiSuggestions[item.unificado]">
              <span
                class="confidence-dot"
                :class="aiSuggestions[item.unificado].confidence"
                :title="aiSuggestions[item.unificado].reason"
              ></span>
              <span
                :title="
                  aiSuggestions[item.unificado].categoryName +
                    ' > ' +
                    aiSuggestions[item.unificado].subCategoryName +
                    ' — ' +
                    aiSuggestions[item.unificado].reason
                "
              >
                {{ aiSuggestions[item.unificado].subCategoryName }}
              </span>
            </template>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>
<script>
import { getProducts } from "@/api/store/ProductsService.js";
import { categorizeProducts } from "@/api/store/AiService.js";
import {
  getCategories,
  getSubcategories,
  addCategoryToProduct
} from "@/api/store/CategoriesService.js";

// Claude clasifica de a 50 productos por request: lotes más grandes alargan
// demasiado la respuesta y arriesgan el timeout del proxy PHP.
const AI_BATCH_SIZE = 50;

function compareSubcategoryName(a, b) {
  if (a.subCategoryName < b.subCategoryName) {
    return -1;
  }
  if (a.subCategoryName > b.subCategoryName) {
    return 1;
  }
  return 0;
}
function compareTitle(a, b) {
  if (a.customTitle < b.customTitle) {
    return -1;
  }
  if (a.customTitle > b.customTitle) {
    return 1;
  }
  return 0;
}
export default {
  name: "BulkCategorySelector",
  data() {
    return {
      showProductModal: false,
      openedProduct: "",
      filters: {
        storeEnabled: "enabled",
        page: 1,
        limitPerPage: "1000",
        orderCol: "nkr_code",
        orderDir: "asc",
        search: "",
        groupByUnificado: true,
        categoryOnly: "no-category-only"
      },
      items: [],
      selectedItem: [],
      currentApiCallId: null,
      loading: false,
      categories: [],
      subCategoriesOptions: [],
      selectedCategory: "",
      selectedSubcategory: "",
      tableFilters: {
        category: ""
      },
      aiSuggestions: {},
      aiUnmatched: [],
      aiRunning: false,
      aiApplying: false,
      aiCancelled: false,
      aiError: "",
      aiProgress: { batch: 0, totalBatches: 0, done: 0, total: 0 }
    };
  },
  async mounted() {
    this.search();
    this.categories = await getCategories();
  },
  computed: {
    allSelected() {
      return (
        this.items.products &&
        this.selectedItem.length == this.items.products.length
      );
    },
    filteredProducts() {
      if (this.items.products) {
        let products = [...this.items.products];
        if (this.tableFilters.category !== "") {
          products = products.filter(product => {
            return (
              product.category &&
              product.category
                .toLowerCase()
                .includes(this.tableFilters.category.toLowerCase())
            );
          });
        }
        return products;
      }
      return [];
    },
    // Sólo se manda a Claude lo que se ve en pantalla y sigue sin categoría.
    // Se mira realCategory, no category: un producto que sólo tiene MARKET >
    // USA sigue estando sin clasificar por tipo de pieza.
    uncategorizedProducts() {
      return this.filteredProducts.filter(product => !product.realCategory);
    },
    suggestionsCount() {
      return Object.keys(this.aiSuggestions).length;
    },
    selectedWithSuggestion() {
      return this.selectedItem.filter(
        unificado => this.aiSuggestions[unificado]
      );
    }
  },
  methods: {
    selectAll(ev) {
      if (ev.currentTarget.checked) {
        this.filteredProducts.forEach(product => {
          this.selectedItem.push(product.unificado);
        });
      } else {
        this.selectedItem = [];
      }
    },
    async loadSubcategories() {
      this.selectedSubcategory = "";
      const subcategories = await getSubcategories(this.selectedCategory);
      this.subCategoriesOptions = subcategories.sort(compareSubcategoryName);
    },
    selectCheckbox(id) {
      document.getElementById(id).click();
    },
    goToPage(page) {
      if (page < 1 || page > this.items.totalPages) {
        return;
      }
      this.filters.page = page;
      this.search();
    },
    clearAiSuggestions() {
      this.aiSuggestions = {};
      this.aiUnmatched = [];
      this.aiError = "";
      this.aiProgress = { batch: 0, totalBatches: 0, done: 0, total: 0 };
    },
    async runAiCategorization() {
      const products = this.uncategorizedProducts;
      if (products.length === 0) {
        return;
      }
      this.clearAiSuggestions();
      this.aiRunning = true;
      this.aiCancelled = false;
      this.aiProgress = {
        batch: 0,
        totalBatches: Math.ceil(products.length / AI_BATCH_SIZE),
        done: 0,
        total: products.length
      };

      const suggestions = {};
      const unmatched = [];
      for (let i = 0; i < products.length; i += AI_BATCH_SIZE) {
        if (this.aiCancelled) {
          break;
        }
        const batch = products.slice(i, i + AI_BATCH_SIZE);
        this.aiProgress.batch = this.aiProgress.batch + 1;
        try {
          const res = await categorizeProducts(batch);
          (res.suggestions || []).forEach(suggestion => {
            suggestions[suggestion.unificado] = suggestion;
          });
          (res.unmatched || []).forEach(unificado => unmatched.push(unificado));
        } catch (e) {
          this.aiError =
            e.response?.data?.error ||
            `Error categorizing batch ${this.aiProgress.batch}`;
          this.$toast.open({
            message: this.aiError,
            type: "error",
            position: "top-right"
          });
          break;
        }
        this.aiProgress.done = Math.min(
          this.aiProgress.done + batch.length,
          products.length
        );
        // Reasignar el objeto completo: Vue 2 no observa claves nuevas.
        this.aiSuggestions = { ...suggestions };
        this.aiUnmatched = [...unmatched];
      }

      // Todo lo sugerido queda preseleccionado; desmarcar una fila la excluye.
      const suggested = Object.keys(this.aiSuggestions);
      this.selectedItem = [
        ...new Set([...this.selectedItem, ...suggested])
      ].filter(unificado =>
        this.filteredProducts.some(product => product.unificado === unificado)
      );

      this.aiRunning = false;
      if (!this.aiError && suggested.length) {
        this.$toast.open({
          message: `${suggested.length} suggestions ready — review and apply`,
          type: "success",
          position: "top-right"
        });
      }
    },
    async applyAiSuggestions() {
      const groups = {};
      this.selectedWithSuggestion.forEach(unificado => {
        const subcategoryId = this.aiSuggestions[unificado].subcategoryId;
        if (!groups[subcategoryId]) {
          groups[subcategoryId] = [];
        }
        groups[subcategoryId].push(unificado);
      });
      const entries = Object.entries(groups);
      if (entries.length === 0) {
        return;
      }
      if (
        !confirm(
          `Assign ${this.selectedWithSuggestion.length} products to ${entries.length} subcategories?`
        )
      ) {
        return;
      }
      this.aiApplying = true;
      let applied = 0;
      let failed = 0;
      for (const [subcategoryId, unificados] of entries) {
        try {
          await addCategoryToProduct(unificados, Number(subcategoryId));
          applied += unificados.length;
        } catch (e) {
          failed += unificados.length;
        }
      }
      this.aiApplying = false;
      this.$toast.open({
        message: failed
          ? `${applied} products categorized, ${failed} failed`
          : `${applied} products categorized`,
        type: failed ? "error" : "success",
        position: "top-right"
      });
      this.clearAiSuggestions();
      this.items = [];
      this.searchFromFirstPage();
    },
    addCategories() {
      addCategoryToProduct(this.selectedItem, this.selectedSubcategory)
        .then(res => {
          this.$toast.open({
            message: res.message,
            type: "success",
            position: "top-right"
          });
          this.items = [];
          this.searchFromFirstPage();
        })
        .catch(() => {
          this.$toast.open({
            message: `Error adding categories`,
            type: "error",
            position: "top-right"
          });
        });
    },
    searchFromFirstPage() {
      this.filters.page = 1;
      this.search();
    },
    async search() {
      this.loading = true;
      this.selectedItem = [];
      const checkbox = document.getElementById("select-all-cb");
      checkbox.checked = false;
      this.currentApiCallId = new Date();
      let apiId = this.currentApiCallId;
      const res = await getProducts(this.filters).catch(() => {
        console.log("Error getting Products");
      });
      if (apiId === this.currentApiCallId) {
        res.products = res.products.sort(compareTitle);
        this.items = res;
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="postcss">
#bulk-category-selector.modal {
  padding: 20px;
  display: flex;
}
#bulk-category-selector .modal-content {
  width: 95%;
  height: 98%;
  padding: 0px;
  margin: auto;
}
#filters,
.item-line {
  @apply p-0;
  display: grid;
  align-items: center;
  grid-gap: 10px;
  text-align: center;
  grid-template-columns: 70px 70px 120px 120px 1fr 1fr 200px 200px;
}
.filters-box {
  position: sticky;
}
.category-field {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.suggestion-field {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.confidence-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.confidence-dot.high {
  background-color: #16a34a;
}
.confidence-dot.medium {
  background-color: #d97706;
}
.confidence-dot.low {
  background-color: #dc2626;
}
/* El scroll vive en .modal-content: la barra queda fija arriba para que
   "Apply suggestions" siga a mano mientras se revisan las filas. */
#ai-categorizer {
  position: sticky;
  top: 0;
  z-index: 50;
}
#ai-categorizer h2 {
  margin: 0;
}
#ai-categorizer button[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
